module.exports = __webpack_public_path__ + "static/media/ua.bd82dfe1.svg";